import { borderColor, textColor } from './color';
export default {
  axisLine: {
    show: true,
    lineStyle: {
      color: borderColor.normal
    }
  },
  axisTick: {
    show: true,
    lineStyle: {
      color: '#ffffff'
    }
  },
  axisLabel: {
    show: true,
    textStyle: {
      color: textColor.gray
    }
  },
  splitLine: {
    show: false
  },
  splitArea: {
    show: false
  }
};